export class UpdateCaracteristicaPropiedadRequest {

    public id: number = 0;
    public id_CaracteristicaPropiedad: number = 0;
    public cantidad: number = 0;
}